/**
 * 前端权限判断工具
 * 登录后后端返回 permissions（当前管理员拥有的按钮级权限标识集合），存于 localStorage.userInfo.permissions
 */
import { getUserInfo } from './auth'

export function getPermissions() {
  // 登录态过期（超过 24 小时）时 getUserInfo 返回空对象
  const userInfo = getUserInfo()
  return userInfo.permissions || []
}

/**
 * 是否拥有指定权限。perm 可为字符串或数组（数组表示满足任一即可）。
 */
export function hasPerm(perm) {
  if (!perm) return true
  const perms = getPermissions()
  const list = Array.isArray(perm) ? perm : [perm]
  return list.some(p => perms.indexOf(p) !== -1)
}
